import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
// import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import elePersonLeft from '../../../../../../assets/2025/topic1400/elePerson_2_1.png';
import elePersonRight from '../../../../../../assets/2025/topic1400/elePerson_2_2.png';
import rightIcon from '../../../../../../assets/2025/topic1400/right_icon.png';
import wrongIcon from '../../../../../../assets/2025/topic1400/wrong_icon.png';
import { WTitle, CTitle } from '../../components/Widget';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  return (
    <div className="topic-section-2">
      <WTitle title={paragraphsSettings?.title} />
      <div className="mv">
        <div className="mv-left">
          <img className="mv-left-person" src={elePersonLeft} alt="" />
          <div
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.tips1,
            }}
          />
        </div>
        <div className="mv-right">
          <img className="mv-right-person" src={elePersonRight} alt="" />
          <div
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.tips2,
            }}
          />
        </div>
      </div>
      <div className="news-title">
        <CTitle title={paragraphsSettings?.newsTitle} />
      </div>
      <div className="news-content">
        <div className="silder news-content-one">
          <div className="silder-title">
            <span>{paragraphsSettings?.l1Title}</span>
            <img src={rightIcon} alt="" />
          </div>
          <div className="silder-list">
            {paragraphsSettings?.l1?.map((item: string, i: number) => (
              <span key={i}>{item}</span>
            ))}
          </div>
        </div>
        <div className="silder news-content-two">
          <div className="silder-title">
            <img src={wrongIcon} alt="" />
            {paragraphsSettings?.l2Title}
          </div>
          <div className="silder-list">
            {paragraphsSettings?.l2?.map((item: string, i: number) => (
              <span key={i}>{item}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
